module.exports = __webpack_public_path__ + "static/logo-1-412cea6d5bfdddb14669ab535833e9ed.jpg";